<template>
  <q-btn
    flat
    round
    size="10px"
    style="width: 30px; height: 40px"
    class="btn--no-hover"
    :ripple="false"
    icon="engp:engp-ico-copy"
    @click.stop="copyUuid()"
  >
    <q-tooltip>Copy uuid</q-tooltip>
  </q-btn>
</template>

<script>
import { copyToClipboard } from 'quasar';

export default {
  name: 'CopyBtn',
  props: {
    copyData: {
      type: String,
    },
    notification: {
      type: String,
      default: 'Item was copied',
    },
  },
  methods: {
    copyUuid() {
      copyToClipboard(this.copyData).then(() => {
        this.$notify('info', 'Info', this.notification);
      });
    },
  },
};
</script>
